import { render } from "./w-loadable.vue?vue&type=template&id=0294e4c6&scoped=true"
import script from "./w-loadable.vue?vue&type=script&lang=js"
export * from "./w-loadable.vue?vue&type=script&lang=js"

import "./w-loadable.vue?vue&type=style&index=0&id=0294e4c6&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0294e4c6"]])

export default __exports__